<template>
  <div class="text-center py-8">
    <!-- Success -->
    <template v-if="success">
      <v-icon size="72" :style="`color: ${colors.primary};`">
        mdi-check-circle-outline
      </v-icon>
      <h2 class="headline font-weight-bold mt-4 mb-2" :style="`color: ${colors.primaryVariant};`">
        {{ isReference ? 'Referencia de pago obtenida exitosamente' : isLastPayment ? '¡Plan de pagos completado!' : 'Pago realizado con éxito' }}
      </h2>

      <template v-if="isLastPayment && !isReference">
        <p class="body-1 mb-4" :style="`color: ${colors.diabledText};`">
          Has liquidado el plan completo. {{ isEvent ? 'Tu acceso con QR al evento fue enviado a tu correo.' : '' }}
        </p>
        <v-chip
          :style="`background: ${colors.active}; color: ${colors.primaryVariant};`"
          class="font-weight-bold"
        >
          <v-icon left small>mdi-check-all</v-icon>
          Plan liquidado
        </v-chip>
      </template>

      <template v-else>
        <p class="body-1 mb-2" :style="`color: ${colors.diabledText};`">
          {{ isReference
            ? `Se generó la referencia para tu pago ${installmentNumber} de ${totalInstallments}. Realiza el pago antes de la fecha de vencimiento.`
            : `Tu pago ${installmentNumber} de ${totalInstallments} fue procesado correctamente.`
          }}
        </p>
        <p v-if="nextDueDate" class="body-2" :style="`color: ${colors.primaryVariant};`">
          <v-icon small :style="`color: ${colors.secondary};`">mdi-calendar-clock</v-icon>
          Próximo pago: <strong>{{ formatDate(nextDueDate) }}</strong>
          — ${{ formatAmount(nextAmount) }} MXN
        </p>
      </template>
    </template>

    <!-- Error -->
    <template v-else>
      <v-icon size="72" :style="`color: ${colors.contrastError};`">
        mdi-alert-circle-outline
      </v-icon>
      <h2 class="headline font-weight-bold mt-4 mb-2" :style="`color: ${colors.primaryVariant};`">
        No se pudo procesar el pago
      </h2>
      <v-alert
        :style="`background: ${colors.error}; color: ${colors.contrastError}; border: none;`"
        class="body-2 text-left mt-3"
      >
        {{ errorMessage || 'Ocurrió un error al procesar tu pago. Por favor intenta de nuevo.' }}
      </v-alert>
      <v-btn
        depressed
        rounded
        class="mt-4 font-weight-bold white--text"
        :style="`background: ${colors.primary};`"
        @click="$emit('retry')"
      >
        Intentar de nuevo
      </v-btn>
    </template>

    <v-row justify="center" class="mt-6">
      <v-col cols="auto">
        <v-btn
          text
          rounded
          :style="`color: ${colors.primaryVariant};`"
          @click="$emit('go-home')"
        >
          Volver al inicio
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { colors } from '@/constants/colors';

export default {
  name: 'PaymentResultScreen',

  props: {
    success: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
    installmentNumber: { type: Number, default: 1 },
    totalInstallments: { type: Number, default: 1 },
    isLastPayment: { type: Boolean, default: false },
    isEvent: { type: Boolean, default: false },
    isReference: { type: Boolean, default: false },
    nextDueDate: { type: [String, Date], default: null },
    nextAmount: { type: Number, default: 0 },
  },

  data() {
    return { colors };
  },

  methods: {
    formatDate(date) {
      if (!date) return '—';
      return new Date(date).toLocaleDateString('es-MX', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    },
    formatAmount(val) {
      if (!val && val !== 0) return '0.00';
      return Number(val).toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>
